import React from 'react'
import { useLocation } from 'react-router'
import styled from 'styled-components'
import { pathRoutes } from '../../../routes/paths'
import logo from '../../../../assets/img/logo.png'
import ButtonTC from '../../../../components/button-tc/button-tc'
import SectionTC from '../../../../components/section-tc/section-tc'
import { NavLink } from 'react-router-dom'
import { MenuAlt2 } from '@styled-icons/heroicons-solid'
import { device } from '../../../../config/theme/breakpoints'
import { ArrowIosForward } from '@styled-icons/evaicons-solid'
import { User } from '@styled-icons/boxicons-regular'
import { SuitcaseRolling } from '@styled-icons/fa-solid'
import { Calendar } from '@styled-icons/feather'
import { CloseCircle } from '@styled-icons/ionicons-outline/CloseCircle'
import SelectTC from '../../../../components/select-tc/select-tc'
import banderaPeru from '../../../../assets/img/bandera_peru.png'

const ContainerNavbar = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  flex-wrap: wrap;
  z-index: 4;

  > div svg {
    width: 100%;
    max-width: 35px;
    color: ${p => p.theme.palette.primary.main};
    cursor: pointer;
  }

  > div img {
    height: 100%;
    max-width: 120px;
    cursor: pointer;

    @media ${device.laptop} { 
      max-width: 180px;
    }
  }
  
  @media ${device.laptop} { 
    justify-content: space-around;
  }
 
  @media ${device.tablet} { 
    height: 70px;
  }
`

const ContainerRoutes = styled.div`
  display: none;
  align-items: center;
  justify-content: center;

  @media ${device.laptop} { 
    display: flex;
  }
`
const ContainerTitle = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  padding: 10px 5px;
`
const TextTitle = styled(NavLink)<{ active: boolean }>`
  color: ${p => p.active ? p.theme.palette.text.black : p.theme.palette.text.gray};
  font-weight: ${props => props.active ? 'bold' : 'normal'} !important;
  text-decoration: none;
  padding: 10px 14px;
  margin: 0;
`
const BorderActiveTitle = styled.div`
  width: 80%;
  height: 2px;
  border-radius: 20px;
  background: red;
  margin: auto;
`

const BurguerMenu = styled.div`
  @media ${device.laptop} { 
    display: none
  }
`
const ContainerButton = styled.div`
  display: none;
  position: relative;

  @media ${device.laptop} { 
    display: block;
  }
`

const ContainerDropdown = styled.div`
  position: absolute;
  top: 55px;
  padding: 5px;
  background: white;
  display: flex;
  flex-direction: column;
  z-index: 2;
  right: 0;
  width: 130%;
  box-shadow: 3px 1px 10px rgb(0,0,0,9%);
  border-radius: 8px;
`

const CustomButton = `
  transition: .2s;

  > div div svg{
    color: white;
  }

  :hover {
    background: #FEA500;
    border: 1px solid #FEA500;

    > div div svg {
      transform: rotate(90deg);
    }
  }
`
const ContainerText = styled.div<{ activeItem: boolean }>`
  color: ${p => p.theme.palette.text.grayLight};
  margin-left: 8px;
  cursor: pointer;
  border-bottom: ${p => p.activeItem ? '1px' : '0px'} solid ${p => p.theme.palette.primary.main};
  
  > div:nth-child(1) {
    font-weight: ${p => p.activeItem ? 'bold' : '100'}
  }
  > div:nth-child(2) {
    width: 0px;
    height: 2px;
    background: ${p => p.theme.palette.secondary.main};
    transition: .3s;
  }

  :hover {
    color: ${p => p.theme.palette.text.gray};

    > div:nth-child(2) {
      width: 40px;
    }
  }
`

const ItemMenuLink = styled(NavLink)`
color: ${p => p.theme.palette.secondary.main};
text-decoration: none;
  padding: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;

  > div svg {
    width: 15px;
    color: ${p => p.theme.palette.secondary.main};  
  }
`
const ContainerLanguage = styled.div`
  width: 100%;
  display: none;
  align-items: center;
  justify-content: flex-end;
  margin-right: 10px;
  max-height: 15px;


  > div {
    display: flex;
    flex-direction: row;
    justify-contenr: center;
    align-items: center;
    max-width: 15%;

    > div img {
      width: 20px;
    }
  }

  @media ${device.laptop} { 
    display: flex;
  }
`

const customLanguaje = `
  margin: 0;
  height: fit-content;
  background: white;

  > select {
    background: white;
  }
`

const customSection = `
  z-index: 8;
`

const listDropdown = [
  {
    icon: <User />,
    text: 'Mi Cuenta',
    to: '/mi-cuenta',
  },
  {
    icon: <SuitcaseRolling />,
    text: 'Récord de Viajes',
    to: '#'
  },
  {
    icon: <Calendar />,
    text: 'Postergaciones',
    to: '#'
  },
  {
    icon: <CloseCircle />,
    text: 'Cerrar Sesión',
    to: '#'
  },
]

interface IOwnProps{
  fixed: boolean;
  onChangeMenu: () => void
}

const Navbar: React.FunctionComponent<IOwnProps> = ({ fixed = false, onChangeMenu }) => {
  const [statusMenu, setStatusMenu] = React.useState(false)
  const location = useLocation()
  const handleAccount = () => setStatusMenu(!statusMenu)
  const handleImage = () => {
    window.location.href = '/'
  }

  return (
    <SectionTC hidden={true} fixed={fixed} classNameSection={customSection}>
      <ContainerNavbar>
        <BurguerMenu onClick={onChangeMenu}>
          <MenuAlt2 />
        </BurguerMenu>
        <ContainerLanguage>
          <div>
            <div><img src={banderaPeru} alt='bandera de peru'/></div>
            <div>
              <SelectTC
                textHolder='Perú - Español'
                className={customLanguaje}
                background='white'
                listOptions={["EEUU - Ingles"]}
              />
            </div>
          </div>
        </ContainerLanguage>
        <div>
          <img src={logo} alt='logo' onClick={handleImage}/>
        </div>
        <ContainerRoutes>
          {pathRoutes.map(route => {
            const activeItem = route.path === location.pathname
            return (
              <ContainerTitle key={route.id}>
                <TextTitle active={activeItem} to={route.path}>
                  {route.name}
                </TextTitle>
                {activeItem && <BorderActiveTitle />}
              </ContainerTitle>
            )
          })}
        </ContainerRoutes>
        <ContainerButton>
          <ButtonTC
            text='Ver mi cuenta'
            className={CustomButton}
            buttonStyle={statusMenu ? 'secondary' : 'primary'}
            icon={<ArrowIosForward />}
            onClick={handleAccount}
          />
          {statusMenu && (
            <ContainerDropdown>
              {listDropdown.map(item => {
                const activeMenuItem = item.to === location.pathname
                return (
                  <ItemMenuLink to={item.to}>
                    <div>{item.icon}</div>
                    <ContainerText activeItem={activeMenuItem}>
                      <div>{item.text}</div>
                      <div />
                    </ContainerText>
                  </ItemMenuLink>
              )})}
            </ContainerDropdown>
          )}
        </ContainerButton>
      </ContainerNavbar>
    </SectionTC>
  )
}

export default Navbar